import React, { FC } from 'react';
import { Nav, BoxProps } from 'grommet';

const NavComponent: FC<BoxProps> = ({ children, ...props }) => {
  return <Nav {...props}>{children}</Nav>;
};

export default NavComponent;
